var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCastbox = function SvgCastbox(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#3b4c6a",
    rx: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M18.853 11.99v7.352a1.071 1.071 0 0 1-2.143 0v-2.074a.729.729 0 0 0-1.421.03h-.003v1.915a1.072 1.072 0 0 1-2.143 0v-2.6a.73.73 0 0 0-1.429 0v5.16a1.072 1.072 0 0 1-2.143 0v-3.79a.657.657 0 0 0-.714-.58.66.66 0 0 0-.714.581v.278a1.072 1.072 0 0 1-2.143 0v-3.31a1.071 1.071 0 0 1 2.143 0v.278a.657.657 0 0 0 .714.581.657.657 0 0 0 .714-.582v-2.385a1.071 1.071 0 1 1 2.143 0v1.008a.73.73 0 0 0 1.429 0v-2.78a1.071 1.071 0 1 1 2.143 0v3.472h.003a.728.728 0 0 0 1.421.03V11.99a1.071 1.071 0 1 1 2.143 0m2.504 1.797a1.063 1.063 0 0 0-1.071 1.054v4.203a1.072 1.072 0 0 0 2.143 0v-4.203a1.064 1.064 0 0 0-1.072-1.054m3.572 2.134a1.063 1.063 0 0 0-1.072 1.054v1.048a1.071 1.071 0 0 0 2.143 0v-1.048a1.063 1.063 0 0 0-1.071-1.054"
  })));
};
export default SvgCastbox;